import { axios } from "../../helper/axios";
import { VendorConstant } from "./vendorConstant";

const VendorApi = {};

VendorApi.getVendorCity = () => {
  return axios.get(VendorConstant.VENDOR_CITY_API);
};

VendorApi.getVendorSeeAllRequest = () => {
  return axios.get(VendorConstant.VENDOR_SEEALLRES_API);
};

VendorApi.ApigetVendorCount = () => {
  return axios.get(VendorConstant.VENDOR_COUNT_API);
};

//post api approve

VendorApi.postApproveRequestApi = (vendor_id,status) => {
  return axios.post(VendorConstant.APPROVE_ENABLE_DISABLE_API,{
    id:vendor_id,
    status:status
  });
};

VendorApi.postRejectRequestApi = (vendor_id,status) => {
  return axios.post(VendorConstant.REJECT_ENABLE_DISABLE_API,{
    id:vendor_id,
    status:status
  });
};

//post api vendor enable disable

VendorApi.postVendorListApi = ({id, status}) => {
  return axios.post(VendorConstant.VENDOR_ENABLE_DISABLE_API,{
    id:id,
    status:status
  });
};

export { VendorApi };
